<template>
  <span>
    <aha-button
      :size="size"
      name="report-page-export-button"
      v-aha-emit-action
      class="button-bg-white w-full"
      :variant="'white'"
      @click="openModalDownload"
    >
      <span class="flex justify-center items-center gap-2">
        <span>{{ $i18nPresenter.t('Export') }}</span>
        <span class="flex items-center gap-1">
          <img src="@/assets/images/icon/excel-icon.svg">
          <img src="@/assets/images/icon/pdf-icon.svg">
        </span>
      </span>
    </aha-button>
    <EditorDownloadReportModal
      v-if="showModalDownload"
      name="report-page-export-modal"
      v-aha-emit-action.view
      @hide="showModalDownload = false"
    >
      <template #item-section>
        <div class="mt-4">
          <DownloadReportSection />
        </div>
      </template>
      <template #info-box-section>
        <AhaInfoBox v-if="isLoadingExport" class="mt-3">
          <div>{{ $i18nPresenter.t('The export is being processed in the background.') }}</div>
          <div>{{ $i18nPresenter.t('Feel free to close this modal.') }}</div>
        </AhaInfoBox>
        <span v-else></span>
      </template>
    </EditorDownloadReportModal>
  </span>
</template>

<script>
import EditorDownloadReportModal from '@/components-v2/presentation-editor/editor-header/EditorDownloadReportModal.vue'
import DownloadReportSection from '@/components-v2/editor-share-v2/DownloadReportSection.vue'
import ExportSection from '@/components-v2/presentation-report/ExportSection.vue'

export default {
  components: {
    EditorDownloadReportModal,
    DownloadReportSection,
  },
  extends: ExportSection,
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      skipParentMounted: true,
      skipParentDestroyed: true,
      showModalDownload: false,
    }
  },
  methods: {
    openModalDownload() {
      this.showModalDownload = true
      this.$emit('hideModal')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
